import discount from "./benefits/discount-benefit.png";
import training from "./benefits/education-benefit.png";
import gas from "./benefits/gas.png";
import groceries from "./benefits/groceries.png";
import gym from "./benefits/gym.png";
import homeOffice from "./benefits/home-office.png";
import itProduct from "./benefits/it-product.png";
import lifeInsurance from "./benefits/life-insurance-benefit.png";
import meal from "./benefits/meal-benefit.png";
import nursery from "./benefits/nursery-benefit.png";
import renting from "./benefits/renting-benefit.png";
import pensionPlan from "./benefits/retirement-insurance-benefit.png";
import retirementInsurance from "./benefits/retirement-insurance-benefit.png";
import transport from "./benefits/transport-benefit.png";
import mealBrand from "./brand/meal-benefit.png";
import pending from "./state/pending.png";
import rejected from "./state/rejected.png";
import refund from "./type/return.png";
import unknown from "./type/unknown.png";
import withdrawal from "./type/withdrawal.png";

export const transactionImage: { [key: string]: string } = {
  pending,
  rejected,
  refund,
  withdrawal,
  cancelled: rejected,
  meal,
  transport,
  nursery,
  training,
  discount,
  "it-product": itProduct,
  "gym-benefit": gym,
  groceries,
  renting,
  "life-insurance": lifeInsurance,
  "retirement-insurance": retirementInsurance,
  "pension-plan": pensionPlan,
  gas,
  "home-office": homeOffice,
  "meal-benefit": mealBrand,
  unknown,
};
